import { Shelf } from "capitalrx-components-2.0/lib/layout";

import { WaysToSaveBox } from "./WaysToSaveBox";
import styles from "./WhiteLabelWaysToSave.module.scss";

export const WaysToSave = () => {
  return (
    <Shelf className={styles.WaysToSave}>
      <p className={styles.WaysToSaveText}>Saving on your medications has never been more simple.</p>
      <Shelf className={styles.WaysToSaveBoxContainer}>
        <WaysToSaveBox icon="coin" number="1" boldText="Find the best price" text="at a pharmacy near you" />
        <WaysToSaveBox icon="card" number="2" boldText="Present your card" text="to the pharmacist" />
        <WaysToSaveBox icon="wallet" number="3" boldText="Start saving" text="on your prescription" />
      </Shelf>
    </Shelf>
  );
};
